import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfFormularios, IConfFormxtab } from '@/modules/Administracion/interfaces'
import type { AxiosResponse } from 'axios'
import type { IFormularios } from '../interfaces/IFormComponent'
import type { IFormulariosMigracionParams, IFormularioMigracionResultado } from '@/modules/Configuracion/interfaces/IFormulariosMigracion'
export class FormularioService extends BaseService<IConfFormularios> {
  constructor () {
    super({
      baseUrl: 'system/forms/'
    })
  }
   // Crear un nuevo elemento
   async createForm(data: IFormularios): Promise<AxiosResponse<IResponseApi<IConfFormularios>>> {
    return this.http.post<IConfFormularios>(`/create`, data).catch(this.errorHandle)
  }

  // Actualizar un elemento por ID
  async updateForm(
    id: number | string,
    data: Partial<IFormularios>
  ): Promise<AxiosResponse<IResponseApi<IConfFormularios>>> {
    return this.http.put<IConfFormularios>(`/update/${id}`, data).catch(this.errorHandle)
  }
  async deleteForm (
    id: number | string
  ): Promise<AxiosResponse<IResponseApi<void>>> {
    return this.http.delete<void>(`/delete/${id}`).catch(this.errorHandle)
  }
  async getCompById (
    id: number | string
  ): Promise<AxiosResponse<IResponseApi<IConfFormxtab[]>>> {
    return this.http.get<IResponseApi<IConfFormxtab[]>>(`/get-components-by-id/${id}`).catch(this.errorHandle)
  }

  async saveMigracion (params: IFormulariosMigracionParams): Promise<AxiosResponse<IResponseApi<{ entidades: IFormularioMigracionResultado[] }>>> {
    return this.http.post<IResponseApi<{ entidades: IFormularioMigracionResultado[] }>>('/save-migracion', params).catch(this.errorHandle)
  }

}
